import { TileLayer } from '@deck.gl/geo-layers';
import { parse } from '@loaders.gl/core';

import { geoBbox } from './tileBbox';
import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

export const geologyLayers = {
  soilTypes:
    'https://mapy.geology.cz/arcgis/rest/services/Pudy/pudni_typy50/MapServer/tile/{z}/{x}/{y}',
};

type GeologyLayers = keyof typeof geologyLayers;
type LayerUrls = typeof geologyLayers[GeologyLayers];

const geologyLayer = (layer: LayerUrls = geologyLayers.soilTypes) =>
  new TileLayer({
    id: 'dmr-layer',
    getTileData: async ({ index: { x, y, z }, bbox }) => {
      const { east, south, north, west } = geoBbox(bbox);
      const url = `https://mapy.geology.cz/arcgis/services/Pudy/pudni_typy50/MapServer/WmsServer?&service=WMS&request=GetMap&layers=0,1&styles=&format=image%2Fpng&transparent=false&version=1.1.1&width=256&height=256&srs=EPSG%3A4326&bbox=${west},${south},${east},${north}`;
      const result = await fetch(url);
      const data = await parse(result);
      return data;
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 0.7,
    renderSubLayers: renderBitmapTileSubLayer,
  });

export { geologyLayer };
